import(/* webpackMode: "eager" */ "/app/src/app/layout.tsx");
